import { aedsService } from "../_services";
const initialState = {
  all: {},
  items: {},
  loading: false,
  filters: {},
  admins: [],
  addressCategories: {},
  parameters: {
    field: "lastUpdated",
    direction: "descending",
    aed: [],
    address: [],
    fadder: [],
    pageNo: 1,
    pageSize: 50
  },
  suggestions: [],
  totalItems: 0,
  totalPages: 0
};
const state = Object.assign({}, initialState);
export const aeds = {
  namespaced: true,
  state: state,
  getters: {
    parameters: state => state.parameters
  },
  actions: {
    getAll: ({ commit }, payload) => {
      commit("getAllRequest");
      commit("updateParameters", payload.parameters);
      aedsService
        .getAll(payload.parameters)
        .then(
          aeds => commit("getAllSuccess", aeds),
          error => commit("getAllFailure", error)
        );
      aedsService
        .getPagination(payload.parameters)
        .then(
          aeds => commit("getPaginationSuccess", aeds),
          error => commit("getAllFailure", error)
        );
    },
    getFilters: ({ commit }) => {
      commit("getAllRequest");
      aedsService
        .getFilters()
        .then(
          filters => commit("getFilters", filters),
          error => commit("getAllFailure", error)
        );
    },
    getAddressCategories: ({ commit }) => {
      commit("getAllRequest");
      aedsService.getAddressCategories().then(
        addressCategories => commit("getAddressCategories", addressCategories),
        error => {
          commit("alert/error", error, { root: true });
          commit("getAllFailure");
        }
      );
    },
    getAdmins: ({ commit }) => {
      commit("getAllRequest");
      aedsService
        .getAdmins()
        .then(
          admins => commit("getAdmins", admins),
          error => commit("getAllFailure", error)
        );
    },
    setToUsersAEDs: ({ commit }, payload) => {
      commit("setToUsersAEDs", payload);
    },
    getSuggestions: ({ commit }, payload) => {
      aedsService
        .getSuggestions(payload)
        .then(
          data => commit("loadSuggestions", data),
          error => commit("alert/error", error, { root: true })
        );
    }
  },
  mutations: {
    getAllRequest(state) {
      state.loading = true;
    },
    getAllSuccess(state, payload) {
      //Override the api interceptor to show results while pagination is pending
      this.dispatch("loadingIndicator/hide");
      state.loading = false;
      state.items = payload;
    },
    getPaginationSuccess(state, payload) {
      state.totalItems = payload.totalItems;
      state.totalPages = payload.totalPages;
    },
    getAllFailure(state) {
      state.loading = false;
    },
    updateParameters(state, parameters) {
      state.parameters = parameters;
    },
    getFilters(state, filters) {
      state.loading = false;
      state.filters = filters;
    },
    getAdmins(state, admins) {
      state.loading = false;
      state.admins = admins;
    },
    getAddressCategories(state, addressCategories) {
      state.loading = false;
      state.addressCategories = addressCategories;
    },
    setToUsersAEDs(state, userID) {
      state.parameters = {
        field: "lastUpdated",
        direction: "descending",
        aed: [],
        address: [],
        fadder: [userID],
        pageNo: 1,
        pageSize: 10
      };
    },
    loadSuggestions(state, suggestions) {
      state.suggestions = suggestions.map(({ type, name }) => ({
        name,
        type: type.charAt(0).toLowerCase() + type.slice(1)
      }));
    },
    clearSuggestions(state) {
      state.suggestions = initialState.suggestions;
    },
    resetState(state) {
      for (let prop in state) {
        state[prop] = initialState[prop];
      }
    }
  }
};
